import { useCurrentOrganization } from 'src/store/organization';

export const getReferralLink = () =>
  `${useCurrentOrganization.getState().currentOrganization.slug}.${process.env.ROOT_NETLOC}/invite`;
